import { defineMessages, IntlShape } from "react-intl";

import { SaleTypeEnum, VoucherTypeEnum } from "../types/globalTypes";

const messages = defineMessages({
  order: {
    defaultMessage: "Entire order",
    description: "voucher discount"
  },
  products: {
    defaultMessage: "Specific products",
    description: "voucher discount"
  },
  shipment: {
    defaultMessage: "Shipment",
    description: "voucher discount"
  },
  exclude: {
    defaultMessage: "Exclude products",
    description: "voucher discount"
  }
});

export const translateVoucherTypes = (intl: IntlShape) => ({
  [VoucherTypeEnum.SHIPPING]: intl.formatMessage(messages.shipment),
  [VoucherTypeEnum.ENTIRE_ORDER]: intl.formatMessage(messages.order),
  [VoucherTypeEnum.SPECIFIC_PRODUCT]: intl.formatMessage(messages.products),
  [VoucherTypeEnum.EXCLUDE_PRODUCT]: intl.formatMessage(messages.exclude)
});

export const translateSaleRangeTypes = (intl: IntlShape) => ({
  [SaleTypeEnum.SPECIFIC_PRODUCT]: intl.formatMessage(messages.products),
  [SaleTypeEnum.EXCLUDE_PRODUCT]: intl.formatMessage(messages.exclude)
});
